var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.video.isLoaded)?_c('v-progress-linear',{attrs:{"id":"video-progress","value":_vm.videoProgress,"background-color":"var(--primary)","background-opacity":"0.2"},on:{"click":function($event){return _vm.jumpTo($event)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }